import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from '@kyruus/intl';
import Banner from '@kyruus/banner';
import { SortFilterBannerContainer } from './styles';
import { NO_SORT_FILTER_BANNER } from '../../lib/constants';

const SortFilterErrorBanner = ({ messages, renderCloseLink, log }) => {
  useEffect(() => {
    log(NO_SORT_FILTER_BANNER);
  }, []);

  return (
    <SortFilterBannerContainer>
      <Banner type="info" icon="!">
        <FormattedMessage
          {...messages.noSortFilterBannerMsg}
          values={{
            closeMessage: renderCloseLink(messages.bannerCloseMsg)
          }}
        />
      </Banner>
    </SortFilterBannerContainer>
  );
};

SortFilterErrorBanner.propTypes = {
  messages: PropTypes.object.isRequired
};

export default SortFilterErrorBanner;
